import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cffe3db6 = () => interopDefault(import('~/pages/_.vue' /* webpackChunkName: "" */))
const _fe9de024 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _cffe3db6,
    name: "about"
  }, {
    path: "/about-eagle-strategies",
    component: _cffe3db6,
    name: "about-eagle-strategies"
  }, {
    path: "/advanced-planning-group",
    component: _cffe3db6,
    name: "advanced-planning-group"
  }, {
    path: "/alliances",
    component: _cffe3db6,
    name: "alliances"
  }, {
    path: "/ash-brokerage",
    component: _cffe3db6,
    name: "ash-brokerage"
  }, {
    path: "/client-dashboard",
    component: _cffe3db6,
    name: "client-dashboard"
  }, {
    path: "/clients",
    component: _cffe3db6,
    name: "clients"
  }, {
    path: "/contact",
    component: _cffe3db6,
    name: "contact"
  }, {
    path: "/copyright",
    component: _cffe3db6,
    name: "copyright"
  }, {
    path: "/eagle-strategies",
    component: _cffe3db6,
    name: "eagle-strategies"
  }, {
    path: "/founder",
    component: _cffe3db6,
    name: "founder"
  }, {
    path: "/individuals-families",
    component: _cffe3db6,
    name: "individuals-families"
  }, {
    path: "/new-york-life",
    component: _cffe3db6,
    name: "new-york-life"
  }, {
    path: "/process",
    component: _cffe3db6,
    name: "process"
  }, {
    path: "/professionals-corporate-executives",
    component: _cffe3db6,
    name: "professionals-corporate-executives"
  }, {
    path: "/retirement-plans",
    component: _cffe3db6,
    name: "retirement-plans"
  }, {
    path: "/scott-ziggy-ziegelmeier",
    component: _cffe3db6,
    name: "scott-ziggy-ziegelmeier"
  }, {
    path: "/services",
    component: _cffe3db6,
    name: "services"
  }, {
    path: "/small-business-owners",
    component: _cffe3db6,
    name: "small-business-owners"
  }, {
    path: "/",
    component: _cffe3db6,
    name: "untitled"
  }, {
    path: "/*",
    component: _fe9de024,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
